import { callApi } from "utils/ContentoApi"

import { Picture } from "./types"

export const fetchPictures = (accountId: string, profileId: string): Promise<Picture[]> =>
  callApi({ method: "get", url: `content-factory/accounts/${accountId}/profiles/${profileId}/pictures` }, true, true)
    .then((response: { pictures: Picture[] }) => response.pictures)
